import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=21fbc6bb&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=21fbc6bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fbc6bb",
  null
  
)

export default component.exports